export default function TableColumns({
  widths,
  fillerWidth,
}: {
  widths: number[];
  fillerWidth: number;
}) {
  return (
    <colgroup>
      {widths.map((width, index) => (
        <col key={index} style={{ width }} />
      ))}
      {fillerWidth > 0 && <col style={{ width: fillerWidth }} />}
    </colgroup>
  );
}
